import '@angular/compiler';
import { PageAccessComponent } from './page.access/page.access.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { PageDashboardComponent } from './page.dashboard/page.dashboard.component';
import { PageReferencesComponent } from './page.references/page.references.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { PagePostsItemComponent } from './page.posts.item/page.posts.item.component';
import { PageReviewComponent } from './page.review/page.review.component';
import { PageMypageComponent } from './page.mypage/page.mypage.component';
import { PortalPostListComponent } from './portal.post.list/portal.post.list.component';
import { ComponentSession_assets_v2Component } from './component.session_assets_v2/component.session_assets_v2.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { PortalPostDetailComponent } from './portal.post.detail/portal.post.detail.component';
import { PagePatientsComponent } from './page.patients/page.patients.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { PageContentComponent } from './page.content/page.content.component';
import { PagePromptsComponent } from './page.prompts/page.prompts.component';
import { ComponentContent_pricing_v2Component } from './component.content_pricing_v2/component.content_pricing_v2.component';
import { ComponentNavSidebarComponent } from './component.nav.sidebar/component.nav.sidebar.component';
import { LayoutSidebarComponent } from './layout.sidebar/layout.sidebar.component';
import { PageAiUsageComponent } from './page.ai.usage/page.ai.usage.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PageAuditComponent } from './page.audit/page.audit.component';
import { PageMembersComponent } from './page.members/page.members.component';
import { PageSignupComponent } from './page.signup/page.signup.component';
import { PagePatientsDetailComponent } from './page.patients.detail/page.patients.detail.component';
import { PageSessionsComponent } from './page.sessions/page.sessions.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { LayoutAuthComponent } from './layout.auth/layout.auth.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { PagePostsComponent } from './page.posts/page.posts.component';
import { PageSettingsComponent } from './page.settings/page.settings.component';
import { ComponentPatientCodeCopyComponent } from './component.patient.code.copy/component.patient.code.copy.component';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, COMPOSITION_BUFFER_MODE } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NuMonacoEditorModule } from '@ng-util/monaco-editor';
import { SortablejsModule } from "src/libs/portal/season/ngx-sortablejs";
import { KeyboardShortcutsModule } from 'ng-keyboard-shortcuts';

// translate libs
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader'
import { HttpClient, HttpClientModule } from '@angular/common/http';

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/lang/', '.json');
}

// initialize ng module
@NgModule({
    declarations: [
        AppComponent,
        PageAccessComponent,
        PortalSeasonTreeComponent,
        PageDashboardComponent,
        PageReferencesComponent,
        PortalSeasonFormDropdownComponent,
        PagePostsItemComponent,
        PageReviewComponent,
        PageMypageComponent,
        PortalPostListComponent,
        ComponentSession_assets_v2Component,
        PortalSeasonModalComponent,
        PortalPostDetailComponent,
        PagePatientsComponent,
        PortalSeasonLoadingDefaultComponent,
        PageContentComponent,
        PagePromptsComponent,
        ComponentContent_pricing_v2Component,
        ComponentNavSidebarComponent,
        LayoutSidebarComponent,
        PageAiUsageComponent,
        PortalSeasonLoadingSeasonComponent,
        PageAuditComponent,
        PageMembersComponent,
        PageSignupComponent,
        PagePatientsDetailComponent,
        PageSessionsComponent,
        LayoutEmptyComponent,
        LayoutAuthComponent,
        PortalSeasonPaginationComponent,
        PagePostsComponent,
        PageSettingsComponent,
        ComponentPatientCodeCopyComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        NgbModule,
        SortablejsModule,
        KeyboardShortcutsModule.forRoot(),
        NuMonacoEditorModule.forRoot({ baseUrl: `lib` }),
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            },
            defaultLanguage: 'en'
        }),
        
    ],
    providers: [
        {
            provide: COMPOSITION_BUFFER_MODE,
            useValue: false
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
